import { axiosPortalInstance } from '@mais-retorno-front/configs/axios-config';
import { GetTermOfDayUseCase } from '@mais-retorno-front/core-business/useCases/glossary/get-term-of-day.usecase';

export const makeGetTermOfDay = () => {
  return new GetTermOfDayUseCase(axiosPortalInstance);
};
